module.exports = __webpack_public_path__ + "static/media/56d62851.jpg";